import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { Commission } from 'src/model/commission.model';

interface UnpaidStaffCommissionInterface {
  StaffUsername: string;
  UnpaidComissionList: Commission[];
}

@Component({
    selector: 'app-add-commission-payment',
    templateUrl: './add-commission-payment.component.html',
    styleUrls: ['./add-commission-payment.component.scss'],
    standalone: false
})
export class AddCommissionPaymentComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);

  companyBankAccountList: Account[] = [];
  cashAccountList: Account[] = [];

  selectedAccountId: number;
  @Input() selectedUsername: string;
  selectedCommissionAmount = 0;
  @Input() unpaidCommission: UnpaidStaffCommissionInterface;
  @Input() selectedBasicAmount: number;
  @Output() passEntry = new EventEmitter<any>();

  //2-WAY BINDING INFO
  paymentDate: Date = new Date();

  disabledSubmit = false;

  ngOnInit(): void {
    const loggedInCompanyId = Number(sessionStorage.getItem('companyId'));
    this.getAllAccountsOfCompany(loggedInCompanyId);
    this.calculateTotalAmount();
  }

  private getAllAccountsOfCompany(companyId: number) {
    // var xhttp = new XMLHttpRequest();
    // var url = "http://localhost:10080/api/v1/company/"+companyId+"/accounts";
    // xhttp.withCredentials = true;
    const loggedInUsername = sessionStorage.getItem("username");
    const xhttp = this.restapi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const account = new Account(json.id, json.number, json.name, json.holderName, json.balance, json.companyId, json.username);

          if (account.Username == undefined)
            this.companyBankAccountList.push(account);
          else if (account.Username == loggedInUsername)
            this.cashAccountList.push(account);
        });
      }
    };
  }

  setSelectedAccount(accountId: number) {
    if (accountId === this.selectedAccountId)
      return true
    else
      return false;
  }
  calculateTotalAmount() {
    for (let i = 0; i < this.unpaidCommission.UnpaidComissionList.length; i++) {
      this.selectedCommissionAmount += this.unpaidCommission.UnpaidComissionList[i].PaymentAmount;
    }
  }

  confirmBeforePayCommission() {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to pay these commissions to " + this.unpaidCommission.StaffUsername + "?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.addPaymentForCommission();
    });
  }

  addPaymentForCommission() {
    this.disabledSubmit = true;

    const isoTaskDate = (new Date(Number(this.paymentDate))).toISOString();
    const commissionList: JSON[] = [];
    for (let i = 0; i < this.unpaidCommission.UnpaidComissionList.length; i++) {
      if (this.unpaidCommission.UnpaidComissionList[i].PaymentAmount > 0) {
        const commission = { "id": this.unpaidCommission.UnpaidComissionList[i].ID, "amount": this.unpaidCommission.UnpaidComissionList[i].PaymentAmount };
        commissionList.push(JSON.parse(JSON.stringify(commission)));
      }
    }

    const data = {
      "accountId": Number(this.selectedAccountId),
      "date": isoTaskDate,
      "commissions": commissionList
    };

    const xhr = this.restapi.postRequest(this.constructApi.getAddCommissionPayout(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;

        if (xhr.status == 200) {
          // var json = JSON.parse(xhr.responseText);

          this.passEntry.emit()
          this.reset();
          this.sharedService.openAlert("Successfully added payment for " + this.unpaidCommission.StaffUsername + "'s commission!", ALERT_TYPE.SUCCESS);

          if (this.selectedBasicAmount != undefined)
            this.addSalaryPayOutExpense();
        }
        else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  addSalaryPayOutExpense() {
    const isoTaskDate = (new Date(Number(this.paymentDate))).toISOString();

    const data = {
      "amount": this.selectedBasicAmount,
      "accountId": Number(this.selectedAccountId),
      "date": isoTaskDate,
      "remark": "SALARY - " + this.selectedUsername
    };

    const xhr = this.restapi.postRequest(this.constructApi.getAddCompanyExpense(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        // var json = JSON.parse(xhr.responseText);

        const account = new Account(this.selectedAccountId, null, null, null, null, null, null, -this.selectedBasicAmount)
        this.passEntry.emit(account)
        this.reset();
        this.sharedService.openAlert("Successfully added salary expense!", ALERT_TYPE.SUCCESS);
      }
    }
  }

  isBalanceInsufficient(balance: number) {
    const total = (this.selectedBasicAmount == undefined) ? this.selectedCommissionAmount : this.selectedBasicAmount + this.selectedCommissionAmount;
    if (balance >= total)
      return false;
    else
      return true;
  }

  submit() {
    if (this.selectedAccountId == undefined)
      this.sharedService.openAlert('Please select account!', ALERT_TYPE.DANGER);
    else
      this.confirmBeforePayCommission();
  }

  reset() {
    this.activeModal.close();
  }
}
